import { useTranslation } from "react-i18next"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { useInitials } from "@/hooks/use-initials"

/**
 * OKS-519 — §13 brand chip header.
 *
 * Small brand avatar + "{Brand} · Crew" strip — the isolation cue that
 * identifies which crew context the board belongs to (UX Spec §2). The
 * logo falls back to brand initials (no placeholder) when unset.
 */
interface BrandChipProps {
  brandName: string
  brandLogoUrl: string | null
}

export function BrandChip({ brandName, brandLogoUrl }: BrandChipProps) {
  const { t } = useTranslation()
  const initials = useInitials()

  return (
    <div
      data-testid="creator-leaderboard-brand-chip"
      className="bg-muted/40 flex items-center gap-2 self-start rounded-full py-1 pr-3 pl-1"
    >
      <Avatar className="size-6">
        {brandLogoUrl ? (
          <AvatarImage src={brandLogoUrl} alt={brandName} />
        ) : null}
        <AvatarFallback className="bg-muted text-[10px] font-medium">
          {initials(brandName)}
        </AvatarFallback>
      </Avatar>
      <span className="text-sm font-medium">
        {t("leaderboard.creator.brand_chip", { brand: brandName })}
      </span>
    </div>
  )
}
